import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsConditions = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
      <Typography variant="h4" gutterBottom>
        Terms & Conditions for Partners (Lead Buyers)
      </Typography>

      <Box>
        <Typography variant="h6" gutterBottom>
          1. Lead Delivery
        </Typography>
        <Typography paragraph>
          Leads are delivered either by email or directly into your CRM, based on your preference set in your Partner Profile. Each lead typically includes name, email, phone number, Eircode, roof type, electricity bill range, grant interest, and installation timeline. Data fields may vary depending on the lead form version.
          If you need this updated at any time, please email declan@bq.ie.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Payment Terms
        </Typography>
        <Typography paragraph>
          Leads are billed weekly in arrears. The billing week runs Saturday to Friday; charges for a given week are processed on the following Monday for the prior week's delivered leads.
        </Typography>
        <Typography paragraph>
          Payment must be made via Direct Debit or Debit/Credit Card.
        </Typography>
        <Typography paragraph>
          By participating, you authorise recurring payments using your selected method. Your leads can be paused at any time.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Cancellation Policy
        </Typography>
        <Typography paragraph>
          You may pause your lead flow at any time by using your Partner Profile or by emailing projects@bq.ie.
        </Typography>
        <Typography paragraph>
          All leads delivered prior to cancellation remain payable in full. All leads are final and non-refundable.
        </Typography>
        <Typography paragraph>
          No future leads will be delivered after cancellation is confirmed.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Lead Usage Policy
        </Typography>
        <Typography paragraph>
          Leads may only be contacted in relation to their original enquiry.
        </Typography>
        <Typography paragraph>
          You may not:
        </Typography>
        <ul>
          <li>Add leads to marketing newsletters or mailing lists</li>
          <li>Share or resell leads</li>
        </ul>
        <Typography paragraph>
          You are expected to follow all relevant GDPR and Irish data protection laws when handling user data. Please consult the EnergyEfficiency privacy policy here for further information: <a href="https://energyefficiency.ie/privacy-policy" target="_blank" rel="noopener noreferrer">https://energyefficiency.ie/privacy-policy</a>
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Targeting and Preferences
        </Typography>
        <Typography paragraph>
          You can set your preferred lead volume and geographic targeting (by county) in your Partner Profile.
        </Typography>
        <Typography paragraph>
          These preferences apply to future lead delivery only and do not affect past leads.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Service Quality Standards
        </Typography>
        <Typography paragraph>
          EnergyEfficiency.ie reserves the right to suspend or remove any partner from the system if:
        </Typography>
        <ul>
          <li>You do not meet the standard of service expected from our recommended installers</li>
          <li>We receive consistent user complaints or negative feedback</li>
          <li>We believe your practices could damage the trust users place in our platform</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          7. Data Protection
        </Typography>
        <Typography paragraph>
          You agree to handle personal data securely and limit use strictly to responding to the original enquiry.
        </Typography>
        <Typography paragraph>
          All data must be stored securely, accessed only by authorised staff, and never retained beyond what is legally necessary.
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Governing Law
        </Typography>
        <Typography paragraph>
          These terms are governed by the laws of Ireland. Any disputes will be handled under the jurisdiction of the Irish courts.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Changes to Terms
        </Typography>
        <Typography paragraph>
          We may update these Terms from time to time. You will be notified of any material changes. Continued use of the platform constitutes acceptance of the updated Terms.
        </Typography>

        <Typography paragraph>
          By accessing and using the lead system on EnergyEfficiency.ie, you confirm that you understand and agree to abide by these Terms & Conditions. If you do not agree, you should not use the platform or accept leads.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsConditions;